import {Component, ElementRef, EventEmitter, forwardRef, Input, NgZone, OnDestroy, OnInit, Optional, Output, Self} from '@angular/core';
import {MatInput} from '@angular/material/input';
import {Platform} from '@angular/cdk/platform';
import {ControlValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR, NgControl, NgForm} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {AutofillMonitor} from '@angular/cdk/text-field';
import {MatFormField, MatFormFieldControl} from '@angular/material/form-field';
import {noop, Subject} from 'rxjs';
import {TdoSearchEvent} from '../tdo-search/models/TdoSearchEvent';

@Component({
  selector: 'app-tdo-input',
  templateUrl: './tdo-input.component.html',
  styleUrls: ['./tdo-input.component.css'],
  providers: [
    {provide: MatFormFieldControl, useExisting: TdoInputComponent},
    // {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MatFormFieldControl), multi: true}
  ]
})
export class TdoInputComponent implements OnInit, OnDestroy, MatFormFieldControl<string>, ControlValueAccessor {
  @Input() placeholder: string;
  @Input() placeholderPosition: string = 'inline'; // inline / above
  @Input() autofilled: boolean;
  @Input() controlType: string;
  @Input() disabled: boolean;
  @Input() empty: boolean;
  @Input() errorState: boolean;
  @Input() focused: boolean;
  @Input() id: string;
  @Input() required: boolean;
  @Input() shouldLabelFloat: boolean;
  @Input() userAriaDescribedBy: string;
  @Input() maxCharacters: number = 0;
  @Input() tVersion: string = '1'  ;

  @Input() width: string;
  @Input() class: string;
  @Input() style: string;

  @Output() change = new EventEmitter();

  stateChanges = new Subject<void>();

  private innerValue: any = '';
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    //
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  onContainerClick(event: MouseEvent): void {
    //
  }

  setDescribedByIds(ids: string[]): void {
    //
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
      this.stateChanges.next();
      this.change.emit(new TdoSearchEvent(this.value));
    }
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onInputFinished(event: any) {
    this.change.emit(event);
  }
}
